// GIISDEC official contact details — single source of truth for the pilot
// portal. Visible address / email / phone strings across the site MUST import
// from here so updates remain centralized and consistent.
//
// PRESERVATION:
//   - Do NOT inline these values across pages — import from here.
//   - Email and telephone helpers below return ready-to-use href strings so
//     <a> tags render correct mailto:/tel: links across all components.

export const GIISDEC_CONTACT = {
  org: 'GIISDEC',
  email: 'info@giisdec.com',
  // Visible phone string keeps the conventional formatting requested by
  // operations. The tel: href strips spaces / parentheses per RFC 3966.
  phoneDisplay: '+233 (0) 302 526 361',
  phoneHref: 'tel:+233302526361',
  emailHref: 'mailto:info@giisdec.com',
  head: {
    label: 'GIISDEC Head Office',
    address: 'Plot 172, House No.10 – Duala Street, Lagos Avenue, East Legon, Accra',
  },
  operations: {
    label: 'GIISDEC Operations Office',
    // Operations address not yet defined — render label only and reuse the
    // official email / phone above (see contact info update brief).
    address: 'Contact the GIISDEC Head Office above for routing to Operations.',
  },
} as const;

export type GiisdecContact = typeof GIISDEC_CONTACT;
